import { useEffect, useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSubscriptionListAction } from 'root-redux/actions/common'
import { selectSubscription } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { useVatInfo } from 'hooks/useVatInfo'

import { eventLogger } from 'services/eventLogger.service'

import { SubscriptionTagsType } from 'root-constants'

import { DEFAULT_DISCOUNT_PERCENTAGE } from './constants'

export const useDiscountOffer = () => {
  const dispatch: TAppDispatch = useDispatch()
  const subscription = useSelector(selectSubscription)
  const userId = useSelector(selectUUID)
  const hasVatInfo = useVatInfo()

  useLayoutEffect(() => {
    const pricesTags = hasVatInfo
      ? `${SubscriptionTagsType.TAX},${SubscriptionTagsType.UNSUBSCRIBE}`
      : `${SubscriptionTagsType.NO_TAX},${SubscriptionTagsType.UNSUBSCRIBE}`

    dispatch(getSubscriptionListAction(pricesTags))
  }, [dispatch, hasVatInfo])

  const discountPercentage = Math.round(
    subscription?.mainPrices.discountPercentage || DEFAULT_DISCOUNT_PERCENTAGE,
  )
  const periodQuantity = subscription?.mainPrices.periodQuantity
  const periodName = subscription?.mainPrices.periodName

  useEffect(() => {
    if (subscription) {
      eventLogger.logDiscountOfferScreenShow(
        `${discountPercentage}% discount on ${periodQuantity}-${periodName}s plan`,
        userId,
      )
    }
  }, [discountPercentage, periodName, periodQuantity, subscription, userId])

  return { subscription, discountPercentage }
}
